<template>
    <div class="relative">
        <button @click="isOpen = !isOpen" class="relative block h-8 w-8 rounded-full overflow-hidden focus:outline-none focus:border-white">
            <img class="h-full w-full object-cover" src="../assets/images/user.png" alt="Profile" />
        </button>
        <button v-if="isOpen" @click="isOpen = false" tabindex="-1" class="fixed inset-0 h-full w-full cursor-default"></button>

        <div v-if="isOpen" class="absolute right-0 mt-2 w-48 bg-white rounded-sm shadow-xl">
            <router-link to="/account" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md">Account</router-link>
            <a href="#" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md">Settings</a>
            <a href="#" @click.prevent="signout" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md">Sign out</a>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isOpen: false,
            };
        },
        methods: {
            signout() {
                this.$store.dispatch("logout")
                    .then(() => {
                        this.$router.push("/login")
                    });
            }
        },
        created() {
            const handleEscape = (e) => {
                if (e.key === "Esc" || e.key === "Escape") {
                    this.isOpen = false;
                }
            };

            document.addEventListener("keydown", handleEscape);
            this.$once("hook:beforeDestroy", () => {
                document.removeEventListener("keydown", handleEscape);
            });
        },
    };
</script>
